import { Link } from 'react-router-dom'
import { SITE, FOOTER_LINKS,ROUTES } from '@/constants'
import { useEffect, useState } from 'react'

// Detects desktop vs mobile so accordions can start collapsed on mobile
// and forced-open on desktop, without the two states fighting each other
// after a user manually taps one open on mobile.
function useIsDesktop(breakpoint = 992) {
  // const [isDesktop, setIsDesktop] = useState(
  //   () => typeof window !== 'undefined' && window.innerWidth >= breakpoint
  // )
  const [isDesktop, setIsDesktop] = useState(false)
  useEffect(() => {
    function check() { setIsDesktop(window.innerWidth >= breakpoint) }
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])
  return isDesktop
}
export default function Footer() {
    // const isDesktop = useIsDesktop()
    // const [openGroup, setOpenGroup] = useState(null);
  const bottomLinks = FOOTER_LINKS.Legal

  return (
    <footer className="footer" role="contentinfo" id="Footer">
      <div className="footer-grid" aria-hidden="true"></div>
      <div className="container">
        <div className="footer-top">
          {/* Brand — always visible, not an accordion */}
          <div className="footer-brand">
            <div  className="footer-logo footer-logo" aria-label={`${SITE.fullName} — home`}>
              <img
                src={SITE.onlyLogo}
                alt={SITE.fullName}
                className="footer-logo-img"
                onError={e => {
                  e.currentTarget.style.display = 'none'
                  e.currentTarget.nextElementSibling.style.display = 'flex'
                }}
              />
              <img
                src={SITE.logoDark}
                alt={SITE.fullName}
                className="footer-logo-img"
                onError={e => {
                  e.currentTarget.style.display = 'none'
                  e.currentTarget.nextElementSibling.style.display = 'flex'
                }}
              />
              
              <span className="footer-logo-fallback">
                <span className="footer-logo-icon"><i className="fa-solid fa-bolt" /></span>
                <span className="footer-logo-text">{SITE.name}</span>
              </span>     
                     
            </div>

            <span className="footer-tagline">{SITE.tagline}</span>
           

             {/* <div className="footer-meta"> */}
             <span className="footer-meta-item" style={{fontSize: "0.7rem",transform: "translateY(10px)",paddingBottom:"1rem"}}>
                <i className="fa-regular fa-asterisk" aria-hidden="true" style={{fontSize:'0.8rem',animation: "spin 1s linear infinite",rotate:"0deg"}} /> Founded in {SITE.founded}
              </span> 
              <div className="footer-iso-badge mt-2 d-flex" >
              {/* <i className="fa-solid fa-shield-halved" aria-hidden="true" /> */}
              <img src="/assets/images/iso_image.png" alt="ISO 9001:2015 Certified" className="footer-iso-img" />
              
              <span>ISO 9001:2015 Certified</span>
            </div>
              
            {/* </div> */}
          

            
          </div>

   {/* <details
  key={`services-${isDesktop}`}
  className="footer-accordion footer-middle-col"
  open={isDesktop}
>
          <summary className="footer-accordion-summary">
  <h3 className="footer-group-heading">Services</h3>
  <i className="fa-solid fa-chevron-down footer-accordion-chevron" />
</summary>
  <div className="footer-dropdown-list">
    {['Consulting', 'Design & Product','Staff Augmentation', 'Software Development', 'Software Testing & QA', 'Managed IT Services', 'AI/ML Solutions'].map(group => (
     <details  key={group} className="footer-dropdown" open={openGroup === group}  onToggle={(e) => {    if (e.target.open) {      setOpenGroup(group);    }  }}
>
        <summary className="footer-dropdown-trigger">
          {group}
          <i className="fa-solid fa-chevron-down footer-dropdown-chevron" aria-hidden="true" />
        </summary>
        <ul className="footer-dropdown-menu">
          {(FOOTER_LINKS[group] || []).map(link => (
            <li key={link.label}>
              <Link to={link.href} className="footer-link">{link.label}</Link>
            </li>
          ))}
        </ul>
      </details>
    ))}
  </div>

</details>   */}
<div>
     <h3 className="footer-group-heading">About Us</h3>
   <p className="footer-desc">{SITE.desc}</p><br/>
   <span className='footer-contact-item'>
                <i className="fa-solid fa-shield-halved footer-contact-icon" aria-hidden="true" /> GST No: {SITE.gstNo}
              </span><br/>
               <span className='footer-contact-item'>
                <i className="fa-solid fa-user footer-contact-icon" aria-hidden="true" /> Sole Proprietor: {SITE.soleProprietor}
              </span>
</div>

          {/* Office — new column, same accordion pattern, contains address + ISO badge */}
          <div>
            <h3 className="footer-group-heading">Connect</h3>
            <div className="footer-address">
              <i className="fa-solid fa-location-dot footer-address-icon" aria-hidden="true" />
              <span style={{ whiteSpace: 'pre-line' }}>{SITE.address}<br /><br />
              {/* For directions <a target='_blank' style={{textDecoration:'Underline'}} href='https://www.google.com/maps?cid=16189463918232723771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF&hl=en&gl=IN&source=embed'>click here</a> */}
              </span>
            </div>
            <div className="footer-social">
              <a href='https://www.google.com/maps?cid=16189463918232723771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAMYASAF&hl=en&gl=IN&source=embed' target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="CruxBytes on Google Maps">
                <i className="fa-solid fa-location-dot" aria-hidden="true" />
              </a>
              <a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="CruxBytes on LinkedIn">
                <i className="fa-brands fa-linkedin-in" aria-hidden="true" />
              </a>

              <a href={ROUTES.SALES_ENQUIRY}  className="footer-social-btn" aria-label="Talk To Sales">
                <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
              </a>
            </div>
            <div className="footer-contact">
              <a href={`mailto:${SITE.social.email}`} className="footer-contact-item">
              
                  <i className="fa-solid fa-envelope text-white footer-contact-icon" />
                 
                <span>{SITE.social.email}</span>
              </a>
              {/* <a href={`https://wa.me/${SITE.social.whatsapp}`} className="footer-contact-item">
                <span className="icon-circle icon-circle--sm footer-contact-icon"><i className="fa-brands fa-whatsapp" /></span>
                <span>{SITE.social.call}</span>
              </a> */}
            </div>
          
            
             
           </div>
          <div>
   <h3 className="footer-group-heading">Quick Links</h3>
    <ul className="footer-link-group-list">
    
      {FOOTER_LINKS.Quick_Link.map(link => (
        <li key={link.label}>
          <Link to={link.href} className="footer-link">
            {link.label}
          </Link>
        </li>
      ))}
    </ul>

  {/* <details
    key={`Discover-${isDesktop}`}
    className="footer-accordion"
    open={isDesktop}
    // style={{ paddingTop: '1.5rem' }}
  >
    <summary className="footer-accordion-summary">
      <h3 className="footer-group-heading">Discover</h3>
      <i className="fa-solid fa-chevron-down footer-accordion-chevron" />
    </summary>
    <ul className="footer-link-group-list">
      {FOOTER_LINKS.Discover.map(link => (
        <li key={link.label}>
          <Link to={link.href} className="footer-link">
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </details> */}
</div>
        </div>

        <div className="footer-bottom">
          <span className='d-flex'>Copyright © 2010 - {new Date().getFullYear()}<br/>{SITE.fullName}.
            {/* <span style={{paddingLeft:'0.5rem'}}><img src="/assets/images/india-flag.png" style={{width:'auto',height:'1.2rem'}} /></span>
            <span style={{paddingLeft:'0.5rem'}}><img src="/assets/images/mii-2.png" style={{width:'auto',height:'1.2rem',backgroundColor:'#fff'}} /></span> */}
         </span>
           {/* <a href="/sample" target='_blank' >Sample Page</a> */}
          <nav className="footer-bottom-links" aria-label="Legal links">
            {bottomLinks.map((link, i) => (
              <span key={link.label} className="footer-bottom-link-wrap">
                <Link to={link.href}>{link.label}</Link>
                {i < bottomLinks.length - 1 && <span className="footer-bottom-divider" aria-hidden="true" />}
              </span>
            ))}
          </nav>
           <span>All rights reserved.</span>
        </div>
      </div>
    </footer>
  )
}